import { Link } from "react-router-dom";

const allServices = [
  {
    slug: "sell-property",
    icon: "ri-home-gear-line",
    title: "Sell Property",
    desc: "Price discovery, verified buyer pools and closure management.",
    link: "/services/sell-property",
  },
  {
    slug: "lease-property",
    icon: "ri-file-list-3-line",
    title: "Lease Property",
    desc: "Tenant sourcing, rent benchmarking and lease structuring.",
    link: "/services/leasing",
  },
  {
    slug: "joint-venture",
    icon: "ri-shake-hands-line",
    title: "Joint Venture",
    desc: "JV structures, partner vetting and revenue-share modelling.",
    link: "/services/jda",
  },
  {
    slug: "redevelopment",
    icon: "ri-building-4-line",
    title: "Redevelopment",
    desc: "FSI study, society consent support and developer bidding.",
    link: "/services/redevelopment",
  },
  {
    slug: "investment",
    icon: "ri-line-chart-line",
    title: "Investment",
    desc: "Curated land and income assets for investor mandates.",
    link: "/contact",
  },
  {
    slug: "valuation",
    icon: "ri-scales-3-line",
    title: "Valuation",
    desc: "Bank-grade valuation with development potential upside.",
    link: "/services/valuation",
  },
  {
    slug: "legal",
    icon: "ri-shield-check-line",
    title: "Legal",
    desc: "Title diligence, conversions, approvals and documentation.",
    link: "/services/legal",
  },
  {
    slug: "property-management",
    icon: "ri-settings-3-line",
    title: "Property Management",
    desc: "Rent, compliance, upkeep and owner reporting.",
    link: "/contact",
  },
  {
    slug: "construction",
    icon: "ri-hammer-line",
    title: "Construction",
    desc: "PMC, contractor selection and execution monitoring.",
    link: "/services/construction",
  },
  {
    slug: "digital-marketing",
    icon: "ri-megaphone-line",
    title: "Digital Marketing",
    desc: "Performance campaigns targeting real buyer intent.",
    link: "/services/digital-marketing",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 md:py-28 bg-background-950">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-20">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-400 mb-4">
            Services
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground-50 leading-tight mb-4">
            Advisory that ends in execution
          </h2>
          <p className="text-foreground-400 text-base md:text-lg">
            Ten end-to-end real estate services. From strategy to signed deal.
          </p>
        </div>

        {/* 10-Card Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5 max-w-7xl mx-auto">
          {allServices.map((s) => (
            <Link
              key={s.slug}
              to={s.link}
              className="group relative rounded-2xl border border-foreground-800/30 bg-foreground-900/20 p-5 md:p-6 hover:border-primary-500/40 hover:bg-foreground-900/40 transition-all duration-300 flex flex-col"
            >
              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 border border-primary-500/20 mb-5 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${s.icon} text-lg text-primary-400`} />
              </div>

              {/* Title */}
              <h3 className="font-display font-semibold text-base text-foreground-100 mb-2 group-hover:text-primary-300 transition-colors">
                {s.title}
              </h3>

              {/* Description */}
              <p className="text-sm text-foreground-400 leading-relaxed">
                {s.desc}
              </p>

              {/* Hover arrow */}
              <div className="mt-auto pt-4 flex items-center gap-1 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                Learn more <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}